import React from 'react';
import authIcon from '../../../assets/img/blog-imgs/blog-userpic1.svg';
import flag from '../../../assets/img/forum-details-imgs/forum-details-flag.svg';
import bookMark from '../../../assets/img/forum-details-imgs/forum-details-bookmark.svg';
import heart from '../../../assets/img/forum-details-imgs/forum-details-heart.svg';
import reply from '../../../assets/img/forum-details-imgs/forum-details-reply.svg';
import trophy from '../../../assets/img/forum-details-imgs/forum-details-Trophy.svg';
import smiling from '../../../assets/img/forum-details-imgs/forum-details-smiling.svg';
const ForumCardDetailsSecond = () => {
    return (
        <div className="col-lg-10">
            <div className='forum-details-card mt-4'>
                <div className='d-flex justify-content-between'>
                    <div className='d-flex justify-content-center align-item-center'> 
                        <span className='pe-3'>
                            <img src={authIcon} alt="" width="50px"/></span>
                        <div>
                            <p className='m-0 text-white'>Ivy Sanders </p>
                            <p className='text-white mt-2'>macrumors 6502a</p>
                        </div>
                    </div>
                    <div>
                        <span>
                            <img src={flag} alt="" />    
                        </span>    
                        <span className='mx-4'><img src={bookMark} alt="" /></span>    
                        <span className='counting'>#2</span>
                    </div>
                </div>
                   <div >
                        <p className='form-details-desc p-3 px-5 ms-3'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus vulputate sagittis malesuada. Integer tempor facilisis quam ac euismod. Nullam nibh purus, viverra ut rhoncus ut, dictum et libero. Aenean tristique ut lorem a vestibulum. In facilisis cursus ex, sed luctus nulla mattis eu. Nam laoreet ligula imperdiet quam ullamcorper vulputate. Nullam in eleifend orci. Sed in scelerisque enim. Phasellus consequat pretium rhoncus. Morbi sollicitudin tincidunt sapien, a congue neque auctor in. Curabitur laoreet efficitur sapien, sit amet vulputate tellus lacinia vitae.</p>
                   </div>
                   <div className='action-bar ps-5 w-50 d-flex justify-content-center align-item-center'>
                       <span className='action-bar-values me-4'> 
                                <img src={heart} alt="" className='me-3' /> 259</span>
                                <span className='action-bar-values me-4'> 
                                <img src={reply} alt="" className='me-3' /> 65</span> <span className='action-bar-values me-4'> 
                                <img src={trophy} alt="" className='me-3' /> 102</span> <span className='action-bar-values me-4'> 
                                <img src={smiling} alt="" className='me-3' /> 74</span>
                       
                   </div>
            </div>
        </div>
    );
};

export default ForumCardDetailsSecond;